module.exports = __webpack_public_path__ + "img/file-jpg.66e4f627.svg";